import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportsService } from 'src/app/services';
import { ReportHeaderColumn } from 'src/app/models/report/ReportHeaderArray';
// import * as XLSX from 'xlsx';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Title } from '@angular/platform-browser';
import { CustomDatePipe } from 'src/app/pipes';
@Component({
  selector: 'bart-run-report',
  templateUrl: './run-report.component.html',
  styleUrls: ['./run-report.component.scss'],
   providers:[ScrollingModule,CustomDatePipe]
})
export class RunReportComponent implements OnInit {
  public objHeaderColumn: ReportHeaderColumn =new ReportHeaderColumn();
  hideStatus: boolean = false;
  constructor(private activatedRoute: ActivatedRoute,private _ReportsService:ReportsService,private titleService: Title,private _datePipe : CustomDatePipe) {
   }
   public vScrollHeight:number=0;
  ngOnInit() {
       this.vScrollHeight=window.innerHeight;
        this.getArgumentList();  
        if(this.exportInExcel) 
        {
          this.showReportLoader=true;
        }
        else
        {
          if(this.reportId>0)
               this.runReport(); 
        }
      this.titleService.setTitle( this.reportName );
  } 

  //Start:Commented By Harikesh on 06-Aug-2020
  // ngAfterViewChecked(){
  //   if(!this.fileDownloaded && this.exportInExcel){
  //     //this.exportexcel();
  //   }
  // }
  //End:Commented By Harikesh on 06-Aug-2020

  public runReportHeaderItem:string;
  public groupColumns:string="";
  public reportFormat:string;
  public reportId:number=null;
  public ParamList:string="";
  public argList:string="";
  public reportData:any;
  public reportTableWidth:number=60;
  public reportRecordCount:number=0;
  public reportRecordMaxCount:number=2000;
  public exportInExcel:boolean=false;
  public fileDownloaded:boolean=false;
  public fileName:string= 'ExcelSheet.xlsx';  
  public reportName:string;
  public showReportLoader:boolean=false;

  runReportParam=  {
    "GETREPORTREPORTID":
      {    
        "reportId":this.reportId
      },
      "RUNREPORT":{
        "ReportID":this.reportId,
        "ParamList":this.ParamList
      }
  }
 

  getArgumentList(){
    this.activatedRoute.queryParams.subscribe(params => {
      this.reportId=params["reportId"];
      for(let key in params)
      {
           if (this.argList != "") {
             this.argList +=  "|" + key + "=" + params[key];
           }
           else {
             this.argList = key + "=" + params[key];
           }  
      }
      this.exportInExcel=false;
         if(params["reportFormat"].toLowerCase()=="excel")
         {
           this.exportInExcel=true;
         }
         if(params["reportName"]!=null)
         {
           this.reportName=params["reportName"].replace(' ',"");
         }
         if(params["resultType"]=="Prelim")
         {
          this.hideStatus = true
         }
         
    });   
  }

  runReport(){
      if(this.runReportParam!=null){
        this.showReportLoader=true;
        this.runReportParam.GETREPORTREPORTID.reportId=this.reportId;
        this.runReportParam.RUNREPORT.ReportID=this.reportId;
        this.runReportParam.RUNREPORT.ParamList=this.argList;
        var request = this.runReportParam
        this._ReportsService.runReport(JSON.stringify(request))
            .subscribe((runReportResponse:any)=>
        {  
          if(runReportResponse.errors!=null && runReportResponse.errors!=undefined)
          {
            alert(runReportResponse.errors);
            window.close();
          }
          else
          {
                this.showReportLoader=false;
                this.reportRecordCount=runReportResponse.RUNREPORT.length;
                if(runReportResponse.RUNREPORT.length>this.reportRecordMaxCount && !this.exportInExcel)
                {
                runReportResponse.RUNREPORT=runReportResponse.RUNREPORT.slice(0,this.reportRecordMaxCount);
                }
                if(runReportResponse!=null){
                  if(runReportResponse.GETREPORTREPORTID.length>0 && runReportResponse.RUNREPORT.length>0){
                    this.runReportHeaderItem=runReportResponse.GETREPORTREPORTID[0].reportRenderColumnList;
                    this.groupColumns=runReportResponse.GETREPORTREPORTID[0].reportGroupColumnList;
                    this.reportData=[];
                    var columnOrder=[];
                    var grouping=[];
                    for(let column of this.runReportHeaderItem.split(',')){
                      columnOrder.push(column);
                    }
                    if(this.hideStatus){
                      const index = columnOrder.indexOf("Status");
                        if (index > -1) { 
                          columnOrder.splice(index, 1); 
                      }
                    }
                    if(this.groupColumns!=null || this.groupColumns!=undefined){
                    for(let groupColumn of this.groupColumns.split(',')){
                          grouping.push(groupColumn);                     
                      }
                    }

                    this.reportData.columnOrder=columnOrder;
                    this.reportData.columns=this.objHeaderColumn.columns; 
                    this.reportData.groupColumns= grouping;  
                    
                  }


                  if(runReportResponse.GETREPORTREPORTID.length>0 && runReportResponse.RUNREPORT.length==0){
                
                    var key, keys = Object.keys(this.objHeaderColumn.columns);
                    var n = keys.length;
                    var newObjHeader={}
                    while (n--) {
                      key = keys[n];
                      newObjHeader[key.toLowerCase()] = this.objHeaderColumn.columns[key];
                    }
                    
                    this.runReportHeaderItem=runReportResponse.GETREPORTREPORTID[0].reportRenderColumnList;
                    this.reportData=[];
                    var columnOrder=[];
                    for(let column of this.runReportHeaderItem.split(',')){
                      columnOrder.push(column.toLowerCase());
                    }         
                    if(this.hideStatus){
                      const index = columnOrder.indexOf("status");
                        if (index > -1) { 
                          columnOrder.splice(index, 1); 
                      }
                    }
                    this.reportData.columnOrder=columnOrder;
                    this.reportData.columns=newObjHeader;                   
                  }


                  var report=[];
                  if(runReportResponse.RUNREPORT.length>0){
                      for(let row of runReportResponse.RUNREPORT){  
                        if(row["DrawDate"] != undefined){
                          row.DrawDate = this._datePipe.transform(row.DrawDate,"local","MM/dd/yyyy")
                        }                    
                        report.push({row});
                      }
                      var reportkeys=runReportResponse.RUNREPORT[0];
                      
                      var keys = Object.keys(reportkeys);
                      for(let keyIndex=0; keyIndex<keys.length;keyIndex++)
                      {
                          var rColumn=this.reportData.columnOrder.filter(
                            x=>x.toLowerCase()===keys[keyIndex].toLowerCase());
                            if(rColumn.length>0)
                            {
                            let index= this.reportData.columnOrder.findIndex(x=>x==rColumn);
                              this.reportData.columnOrder[index]=keys[keyIndex];
                              this.reportTableWidth+=Number(this.objHeaderColumn.columns[keys[keyIndex]].width);
                             
                            }  
                            
                            if(this.reportData.groupColumns.length>0){
                            var rGrpColumn=this.reportData.groupColumns.filter(
                              x=>x.toLowerCase()===keys[keyIndex].toLowerCase());
                              if(rGrpColumn.length>0 && this.reportData.groupColumns!=null)
                              {
                              let grpColumnIndex= this.reportData.groupColumns.findIndex(x=>x==rGrpColumn);
                                this.reportData.groupColumns[grpColumnIndex]=keys[keyIndex];                              
                              } 
                            } 

                      }

                      this.reportData.report=report;
                      
                  }             
                }
            }
        },
        (resp)=>
          {
          
            //console.log(resp);
            alert(resp.error.errors);
            window.close();
          }
        
        );
      }
  }
  getReportRowClass(rNumber:number)
  {
    let rowClass = 'trOdd';
    if (rNumber % 2 == 0) {
        rowClass = 'trEven';
    }
    return rowClass;
  }
 

  styleObject(type:String,width:String):Object {
      if(type=="number"){
        return {"text-align": "right","width": width+"px"}
      }  
      if(type=="string"){
        return {"text-align": "left","width": width+"px"}
      }   
      if(type=="date" || type=='datetime'){
        return {"text-align": "center","width": width+"px"}
      }    
    }

}
